/** Marks a SearchInput that the app-wide `/` shortcut may focus. */
export const PAGE_SEARCH_ATTR = "data-page-search";
